import {
  useEffect, useState,
} from 'react';
import { Device } from '../types';
import { getDeviceInfoRequest } from '../utils/api';
import { useDeviceId } from './useDeviceId';

type UseGetDeviceInfoReturn = {
  isLoading: boolean,
  device?: Device,
  isPending: boolean
};

// eslint-disable-next-line import/prefer-default-export,@typescript-eslint/explicit-module-boundary-types
export const useGetDeviceInfo = (): UseGetDeviceInfoReturn => {
  const deviceId = useDeviceId();
  const [state, setState] = useState({
    isLoading: true,
    device: undefined as Device | undefined,
    isPending: false,
  });

  useEffect(() => {
    const getDeviceInfo = async (): Promise<void> => {
      try {
        const response = await getDeviceInfoRequest({ deviceId });

        if (response.device) {
          setState({ isLoading: false, device: response.device, isPending: false });
        } else if (response.isPending === true) {
          setState({ isLoading: false, device: undefined, isPending: true });
        } else {
          setState({ isLoading: false, device: undefined, isPending: false });
        }
      } catch (error) {
        console.error('Error getting device info:', error);
        setState({ isLoading: false, device: undefined, isPending: false });
      }
    };

    getDeviceInfo();
    // eslint-disable-next-line
  }, []);

  return state;
};
